import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import PackagesSection from "@components/PackagesSection";
import SectionHeader from "../components/SectionHeader";

function Packages() {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div>
			<Helmet>
				<title>
					Driving Lesson Packages Canberra | Manual & Automatic Driving Lessons
				</title>
				<meta
					name="description"
					content="Professional driving lessons in Canberra with manual and automatic cars. ACT-based instructors offer flexible lesson packages for learners and test preparation."
				/>
				<link
					rel="canonical"
					href="https://steersmartdriving.com.au/packages"
				/>
			</Helmet>
			<div className="flex flex-col gap-12 py-6 md:py-12">
				<SectionHeader
					title="Driving Lesson Packages"
					subtitle="Our driving lesson packages in Canberra cover a range of learning needs and experience levels. Whether you’re starting from the basics, gaining confidence on the road, or preparing for your driving test, our packages include both manual and automatic driving lessons across ACT and Queanbeyan."
					heading="h1"
				/>
				<PackagesSection all={true} />
			</div>
		</div>
	);
}

export default Packages;
